export const TOGGLE_LOCALE = 'TOGGLE_LOCALE';
export const DELETE_LOCALE = 'DELETE_LOCALE';
